import Cookies from 'js-cookie';

const REFRESH_API_ENDPOINT = 'https://system.sales-management.cloud/api/refresh_token.php';

/**
 * トークンをリフレッシュする関数
 * @returns {Promise<boolean>} リフレッシュ成功時はtrue、失敗時はfalse
 */
export const refreshToken = async () => {
  try {
    const currentToken = Cookies.get('auth_token');
    
    if (!currentToken) {
      console.warn('No token found for refresh');
      return false;
    }

    const response = await fetch(REFRESH_API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${currentToken}`
      },
      body: JSON.stringify({
        revoke_old_token: true,
        expires_in_days: 7
      })
    });

    const data = await response.json();

    if (data.status === 'success') {
      // 新しいトークンをCookieに保存
      Cookies.set('auth_token', data.data.token, { expires: 7, path: '/' });

      console.log('Token refreshed successfully.');
      
      // ユーザー情報を更新
      if (data.data.user) {
        Cookies.set('user_info', JSON.stringify({
          id: data.data.user.id,
          name: data.data.user.name,
          username: data.data.user.username,
          role: data.data.user.role
        }), { expires: 7, path: '/' });
      }

      // トークン情報を更新
      if (data.data.token_info) {
        Cookies.set('token_info', JSON.stringify(data.data.token_info), { expires: 7, path: '/' });
      }

      console.log('Token refreshed successfully');
      return true;
    } else {
      console.error('Token refresh failed:', data.message);
      return false;
    }
  } catch (error) {
    console.error('Token refresh error:', error);
    return false;
  }
};

/**
 * トークンリフレッシュのインターバルを設定
 * @param {number} intervalMinutes リフレッシュ間隔（分）
 * @returns {number} インターバルID
 */
export const setupTokenRefresh = (intervalMinutes = 30) => {
  // 定期実行を設定
  const intervalId = setInterval(() => {
    refreshToken();
  }, intervalMinutes * 60 * 1000);

  return intervalId;
};

/**
 * トークンリフレッシュのインターバルをクリア
 * @param {number} intervalId インターバルID
 */
export const clearTokenRefresh = (intervalId) => {
  if (intervalId) {
    clearInterval(intervalId);
  }
};
